import React from "react";
import Navbar from "../components/Navbar";
import { useTranslation, Trans } from "react-i18next";
import Seo from "../components/Seo";

const AccountDeletion = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const isMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 480px)").matches;

  const pageStyle = {
    backgroundColor: "#1C1C17",
    color: "white",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  };

  const contentStyle = {
    maxWidth: "800px",
    width: "100%",
    margin: "0 auto",
    padding: "20px",
    boxSizing: "border-box",
  };

  const titleContainerStyle = {
    textAlign: "center",
    padding: isMobile() ? "90px 0 20px" : "90px 0 40px",
  };

  const titleStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const lastUpdatedStyle = {
    fontSize: "0.9rem",
    opacity: "0.7",
  };

  const subtitleStyle = {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginTop: "30px",
    marginBottom: "15px",
  };

  const textStyle = {
    fontSize: "1rem",
    lineHeight: "1.6",
    marginBottom: "15px",
  };

  const listStyle = {
    paddingLeft: isRTL ? "0" : "18px",
    paddingRight: isRTL ? "15px" : "0",
    marginBottom: "15px",
  };

  const linkStyle = {
    color: "#4DA8DA",
    textDecoration: "none",
  };

  return (
    <div style={pageStyle}>
      <Seo
        title="Account Deletion | Nightly"
        description="Learn how to request deletion of your Nightly account and what information is deleted or retained."
        path="/account-deletion"
      />
      <Navbar />
      <div style={contentStyle}>
        <div style={titleContainerStyle}>
          <h1 style={titleStyle}>{t("account_deletion.title")}</h1>
          <p style={lastUpdatedStyle}>{t("account_deletion.last_updated")}</p>
        </div>

        <p style={textStyle}>{t("account_deletion.introduction_text")}</p>

        <h2 style={subtitleStyle}>
          {t("account_deletion.how_to_request_title")}
        </h2>
        <ol style={listStyle}>
          <li>
            <Trans
              i18nKey="account_deletion.how_to_request_list_1"
              components={{
                email: (
                  <a
                    href="mailto:support@nightly.co?subject=Account%20Deletion%20Request%20-%20Nightly%20App&body=Google%20email%20used%20to%20sign%20in%3A%20"
                    style={linkStyle}
                  >
                    support@nightly.co
                  </a>
                ),
              }}
            />
          </li>
          <li>{t("account_deletion.how_to_request_list_2")}</li>
          <li>{t("account_deletion.how_to_request_list_3")}</li>
        </ol>
        <p style={textStyle}>{t("account_deletion.verification_note")}</p>

        <h2 style={subtitleStyle}>{t("account_deletion.what_deleted_title")}</h2>
        <p style={textStyle}>{t("account_deletion.what_deleted_text")}</p>
        <ul style={listStyle}>
          <li>{t("account_deletion.what_deleted_list_1")}</li>
          <li>{t("account_deletion.what_deleted_list_2")}</li>
          <li>{t("account_deletion.what_deleted_list_3")}</li>
          <li>{t("account_deletion.what_deleted_list_4")}</li>
        </ul>

        <h2 style={subtitleStyle}>
          {t("account_deletion.what_retained_title")}
        </h2>
        <p style={textStyle}>{t("account_deletion.what_retained_text")}</p>
        <ul style={listStyle}>
          <li>{t("account_deletion.what_retained_list_1")}</li>
          <li>{t("account_deletion.what_retained_list_2")}</li>
          <li>{t("account_deletion.what_retained_list_3")}</li>
        </ul>

        <h2 style={subtitleStyle}>
          {t("account_deletion.retention_period_title")}
        </h2>
        <ul style={listStyle}>
          <li>{t("account_deletion.retention_period_list_1")}</li>
          <li>{t("account_deletion.retention_period_list_2")}</li>
        </ul>

        <h2 style={subtitleStyle}>
          {t("account_deletion.processing_time_title")}
        </h2>
        <p style={textStyle}>{t("account_deletion.processing_time_text")}</p>

        <h2 style={subtitleStyle}>{t("account_deletion.contact_title")}</h2>
        <p style={textStyle}>
          <Trans
            i18nKey="account_deletion.contact_text"
            components={{
              email: (
                <a href="mailto:support@nightly.co" style={linkStyle}>
                  support@nightly.co
                </a>
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default AccountDeletion;
